module.exports = __webpack_public_path__ + "img/icon-activity-email.5552215c.svg";